import {inject} from 'aurelia-framework';
import { Api } from './api';

export const AppEnv 	= { Production:"Production", Dev:"Dev" }
export const app_env 	= AppEnv.Production;

export class Request {
	constructor(url, method){
		this.url 		= url;
		this.method 	= method
		this.headers 	= {
			 'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*'
		}
	}
}

export const AuthStatus = {
	"Ok"				:"Ok",
	"Unauthenticated"	:"Unauthenticated",
}

//export const CookieDomain = (app_env === AppEnv.Production) ? ";domain=localhost;path=/;SameSite=None;Secure";
// ";domain=samantia.com;path=/;SameSite=None;Secure"

export const CookieDomain = (app_env === AppEnv.Production) ? ";domain=samantia.com;path=/;SameSite=None;Secure" : ";domain=localhost;path=/;SameSite=None;Secure";

export class DataService {
	constructor(){
		this.auth_status 	= AuthStatus.Unauthenticated;
		this.user		 	= null;
		this.cookie_domain	 = ";domain=localhost;path=/;SameSite=None;Secure";
	}
}
